import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './ui/LoadingScreen';

interface ProtectedRouteProps {
  children: ReactNode;
  /** require the admin role as well as a session */
  admin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, admin = false }) => {
  const { currentUser, loading, isAdmin } = useAuth();
  const location = useLocation();

  // only block on the initial session check; later mutations (profile save) also toggle loading
  if (loading && !currentUser) return <LoadingScreen fullscreen />;
  if (!currentUser) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (admin && !isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default ProtectedRoute;
